import React from 'react';
import QrCode from '../produkte/QrCode';

const CardVorschau = ({ bildInfos }) => {
  let farbe;
  let qr;
  let qrFarbe;
  let bild;
  if (bildInfos.startsWith('{"Farbe')) {
    const tempBild = JSON.parse(bildInfos);
    farbe = tempBild.Farbe;
    qr = tempBild.QR_Code;
    qrFarbe = tempBild.QR_Code_Farbe;
  } else {
    bild = bildInfos;
  }

  return (
    <div className="aspect-[1.586/1] sm:mb-0 mb-6">
      {bild ? (
        <img
          src={bild}
          alt="sVisit Custom Karte"
          className="h-full w-full flex-none rounded-lg object-cover"
        />
      ) : (
        <div
          className="h-full w-full flex-none rounded-lg grid place-items-center"
          style={{ backgroundColor: farbe }}
        >
          <div className="w-1/3">{qr ? <QrCode color={qrFarbe} /> : ''}</div>
        </div>
      )}
    </div>
  );
};

export default CardVorschau;
